// Tracks the pathname the user navigated from, updated on every SPA
// navigation via the router subscription set up in main.tsx. Undefined
// until the first in-app navigation happens (e.g. on initial page load).
let previousPathname: string | undefined;

export function getPreviousPathname(): string | undefined {
  return previousPathname;
}

export function setPreviousPathname(pathname: string | undefined): void {
  previousPathname = pathname;
}
